import React, { ChangeEvent, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import galleryIcon from "../../../../assets/icons/gallery.png";
import { uploadOneFiles } from "./../../../../../src/fileUploader/SingleFileUploader.js";
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx';
import jwt_decode from 'jwt-decode';

function EditFoodCategoryDialog(props) {
  const [categoryName, setCategoryName] = useState('');
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [imageFiles, setImageFiles] = useState<File[]>([]);
  const [userId, setUserId] = useState<string | undefined>();
 // const [CreatorRestaurantId, setCreatorRestaurantId] = useState('');
  const [categoryData, setCategoryData] = useState({
    Id: '',
    CategoryName: '',
    IsActive: true,
    CreatorId: '',
    CreationDate: '',
    ModifierId: '',
    ModificationDate: '',
    CategoryImagePath: '',
    
  });

  const apiAddress = process.env.REACT_APP_SECRET;

  useEffect(() => {
     
      loadCategoryData();
    
  }, [props.selectedId]);

  const token = localStorage.getItem("token");



  const loadCategoryData = () => {
    if (token) {
      try {
        const decodedData = jwt_decode(token);
        setUserId(decodedData?.UserId); 
        //(decodedData.RestaurantId);  
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  
    axios({
      method: 'get',
      url: apiAddress + '/api/FoodCategory/GetFoodCategoryById?id=' + props.selectedId
    })
      .then((response) => {
        const data = response.data;
        if (data) {
          setCategoryData(data);
          setCategoryName(data.categoryName);
          if (data.categoryImagePath) {
            setSelectedImages([data.categoryImagePath]);
          }
        }
      })
      .catch((error) => {
        console.error("Error loading category data:", error);
        toast.error("Failed to load category data", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  

  const handleClose = () => {
    props.onHandleAddItem(false);
    resetForm();
  };

  useEffect(() => {
console.log(categoryName)
  }, [categoryName]);


  const resetForm = () => {
    setCategoryName('');
    setSelectedImages([]);
    setImageFiles([]);
  };

  const fileUpload = async () => {
    if (imageFiles.length > 0) {
      try {
        const res = await uploadOneFiles(imageFiles[0]);
        return res[0]; // Return the image URL
      } catch (error) {
        console.error("File upload error:", error);
        throw error;
      }
    }
    return categoryData.CategoryImagePath; // Return existing image URL if no new image
  };

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 1 - selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);

      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        setImageFiles((prevItems) => [...prevItems, file]);

        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            setSelectedImages((prevImages) => [...prevImages, ...imagesArray]);
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...selectedImages];
    const updatedImageFiles = [...imageFiles];
    updatedImages.splice(index, 1);
    updatedImageFiles.splice(index, 1);
    setImageFiles(updatedImageFiles);
    setSelectedImages(updatedImages);
  };

  // const handleSubmit = async () => {
  //   let valid = true;

  //   if (categoryName.trim() === "") {
  //     valid = false;
  //     toast.error("Category Name is required", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //   }

  //   if (valid) {
  //     try {
  //       const imageUrl = await fileUpload();
  //       const updatedCategoryData = { ...categoryData, CategoryName: categoryName, CategoryImagePath: imageUrl };

  //       // await axios({
  //       //   method: 'post',
  //       //   url: ${apiAddress}/api/FoodCategory/UpdateFoodCategory,
  //       //   data: updatedCategoryData,
  //       // });

  //       axios({
  //                     method: 'put',
  //                     url: apiAddress + '/api/FoodCategory/updateFoodcategory',
  //                     data: updatedCategoryData               
  //                 })

  //       toast.success("Successfully Updated", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "colored",
  //       });

  //       props.onHandleAddItem(false);
  //     } catch (error) {
  //       console.error('Error during submission:', error);
  //       toast.error("Failed to update category", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "colored",
  //       });
  //     }
  //   }
  // };


  const handleSubmit = async () => {
    let valid = true;
  
    if (categoryName.trim() === "") {
      valid = false;
      toast.error("Category Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  
    if (valid) {
      try {
        const imageUrl = await fileUpload();  
        const updatedCategoryData = {
          ...categoryData,
          CategoryName: categoryName,
          CategoryImagePath: imageUrl,
          ModifierId: userId, 
        };
  
        const token = localStorage.getItem("token");
        const decodedData = jwt_decode(token);
        const RequestingRestaurantId = decodedData?.RestaurantId; 

        const response = await axios({
          method: 'put',
          url: apiAddress + '/api/FoodCategory/updateFoodcategory?requestingRestaurantId='+RequestingRestaurantId,
          data: {
            ...updatedCategoryData,
          
          }
        });

  
        toast.success("Successfully Updated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
  
        props.onHandleAddItem(false);  
      } catch (error) {
        console.error('Error during submission:', error);
        toast.error(error.response?.data || "Failed to update category", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };


  return (
    <div>
      <Dialog fullWidth={true} open={props.open} onClose={handleClose}>
        <ToastContainer />
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Edit Category</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container sx={{ padding: '0.5rem' }}>
            <Grid item xs={2}>
              <Typography style={{ paddingTop: '1rem' }}>Category Name</Typography>
            </Grid>
            <Grid item xs={10}>
              <TextAreaComponents
                label={'Category Name'}
                value={setCategoryName}
                //onChange={(e) => setCategoryName(e.target.value)}
                val={categoryName}

              />
            </Grid>
          </Grid>

          <Grid container sx={{ padding: '0.5rem' }}>
            <Grid item xs={2}>
              <Typography style={{ paddingTop: '1rem' }}>Image</Typography>
            </Grid>
            <Grid item xs={9}>
              <Button
                variant="contained"
                component="label"
                style={{ backgroundColor: 'white', color: 'gray' }}
              >
                <img src={galleryIcon} alt="gallery-Icon" style={{ width: '2rem' }} />
                Upload
                <input
                  hidden
                  accept="image/*"
                  multiple
                  type="file"
                  onChange={handleImageUpload}
                  disabled={selectedImages.length >= 1}
                />
              </Button>
            </Grid>
          </Grid>

          <Grid container sx={{ padding: '0.5rem' }}>
            <Grid item xs={2}></Grid>
            <Grid item xs={9}>
              <Grid container spacing={2}>
                {selectedImages.map((image, index) => (
                  <Grid item xs={2} sm={2} md={2} key={index}>
                    <div style={{ position: 'relative', paddingTop: '20px' }}>
                      <img
                        src={image}
                        alt="Selected"
                        style={{ width: '100%' }}
                      />
                      <IconButton
                        style={{ position: 'absolute', top: '-6px', right: '-23px', color: 'gray' }}
                        onClick={() => handleDeleteImage(index)}
                      >
                        <CancelIcon />
                      </IconButton>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} color="primary">Update</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EditFoodCategoryDialog;